import resolveRoute from '@/router/resolveRoute'

/**
 * This take vue router route object and resolves that to url string.
 * @param location
 * @returns {`${string}${string}`}
 */
export default location => {
  const routePath = resolveRoute(location).route.fullPath
  return `${window.location.origin}${routePath}`
}
